/**
 * Saving the exported workbook.
 *
 * The API returns the workbook inline as base64 rather than as a URL: release 1
 * stores nothing, so there is no object to link to. Converting it here keeps
 * that decision in one place - when a bucket and signed URLs arrive, only this
 * function changes.
 */

const XLSX_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

/**
 * Prompts the browser to save a base64 payload as a file.
 *
 * @param base64 - The encoded file contents.
 * @param filename - Suggested name for the download.
 * @param mimeType - Content type; defaults to xlsx.
 */
export function downloadBase64(
  base64: string,
  filename: string,
  mimeType: string = XLSX_TYPE,
): void {
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let index = 0; index < binary.length; index += 1) {
    bytes[index] = binary.charCodeAt(index);
  }

  const url = URL.createObjectURL(new Blob([bytes], { type: mimeType }));
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();

  // Released on the next tick: revoking synchronously can cancel the download
  // in some browsers before it has started reading the blob.
  window.setTimeout(() => URL.revokeObjectURL(url), 0);
}
